
import {takeUntil} from 'rxjs/operators';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Subject } from 'rxjs';
import { ActimoveService } from './Actimove.service';
import { IActimoveSegment } from '../../../model/product/tena/actimove/IActimoveSegment';
import { IActimoveWebShopCatalogApi } from '../../../model/product/tena/actimove/IActimoveWebShopCatalogApi';

@Component({
    selector: 'admin-actimove-country-segment-menu',
    templateUrl: 'ActimoveCountrySegmentMenu.component.html'
})
export class ActimoveCountrySegmentMenuComponent implements OnInit, OnDestroy {
    countryModalVisible: boolean;
    segmentModalVisible: boolean;
    country: IActimoveWebShopCatalogApi;
    segment: IActimoveSegment;

    @Input()
    useSegment = true;

    private unsubscribe: Subject<void> = new Subject();

    constructor(private actimoveService: ActimoveService) {}

    ngOnInit() {
        // First show country popup and then segment popup.
        this.initializeCountryModal();
    }

    initializeCountryModal(): void {
        this.actimoveService.countryModalVisible.pipe(
            takeUntil(this.unsubscribe))
            .subscribe(visible => {
                this.countryModalVisible = visible;
            });

        this.actimoveService.countryChanged.pipe(takeUntil(this.unsubscribe)).subscribe(country => {
            if (country) {
                this.country = country;

                if (this.useSegment) {
                    // Now show segment popup
                    this.initializeSegmentModal();
                }
            }
        });

        let sessionStorageCountry = this.actimoveService.getActiveCountry();
        if (sessionStorageCountry) {
            this.actimoveService.countryChanged.next(sessionStorageCountry);
            this.actimoveService.countryModalVisible.next(false);
        } else {
            this.actimoveService.countryModalVisible.next(true);
        }
    }

    initializeSegmentModal(): void {
        this.actimoveService.segmentModalVisible.pipe(
            takeUntil(this.unsubscribe))
            .subscribe(visible => {
                this.segmentModalVisible = visible;
            });

        this.actimoveService.segmentChanged.pipe(takeUntil(this.unsubscribe)).subscribe(segment => {
            if (segment) {
                this.segment = segment;
            }
        });

        let sessionStorageSegment = this.actimoveService.getActiveSegment();
        if (sessionStorageSegment) {
            this.actimoveService.segmentChanged.next(sessionStorageSegment);
            this.actimoveService.segmentModalVisible.next(false);
        } else {
            this.actimoveService.segmentModalVisible.next(true);
        }
    }

    selectSegment() {
        this.actimoveService.segmentModalVisible.next(true);
    }

    selectCountry() {
        this.actimoveService.countryModalVisible.next(true);
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
